.bam-footer {

  &--compressed {
    width: 100%;
    padding: 0 16px;
    transition: max-width 0.3s ease-in-out,
                padding 0.3s ease-in-out;

    .bam-footer__content-wrapper {
      border-radius: 12px 12px 0 0;
      transition: border-radius 0.3s ease-in-out;
    }

    @include desktop {
      padding: 0 32px;
      max-width: 992px;
    }
  }

  &--fullwidth {
    width: 100%;
    max-width: 100%;
    padding: 0;
    transition: max-width 0.3s ease-in-out,
                padding 0.3s ease-in-out;

    .bam-footer__content-wrapper {
      width: 100%;
      border-radius: 0 0 0 0;
      transition: border-radius 0.3s ease-in-out;
    }
  }

  .bam-footer__content-wrapper {
    background-color: var(--bal-color-primary);
    // color: var(--bal-color-white);

    .container {
      padding-bottom: 64px;

      @include desktop {
        padding-bottom: 96px;
      }

      .bam-footer__logo-wrapper {
        .bal-logo {
          margin-bottom: 32px;

          @include desktop {
            margin-bottom: 0
          }
        }
      }

      bam-footer-navigation {
        padding: 0;

        @include desktop {
          padding-right: 1rem;
          padding-left: 1rem;
          margin-bottom: 3rem;

          &:first-of-type {
            padding-left: 0;
          }

          &:last-of-type {
            padding-right: 0;
          }
        }
      }

      .bam-footer__meta-list-wrapper {

        .bam-footer__social-list {
          justify-content: center;
          margin-bottom: 3rem;

          @include tablet {
            justify-content: center;
            margin-bottom: 4rem;
          }

          @include desktop {
            justify-content: flex-start;
            margin-bottom: 0
          }

          .social-icons__listitem {
            border-radius: 4px;
            padding: 2px;

            &:hover {
              & a bal-icon {
                & svg,
                & svg path {
                  fill: var(--bal-tabs-tab-button-label-text-color-inverted-hover) !important;
                }
              }
            }

            &:focus-within {
              box-shadow: var(--bal-focus-shadow-inverted) !important;
            }
          }
        }

        .bam-footer__meta-list {
          flex-direction: column;
          align-items: center;

          @include tablet {
            flex-direction: row;
            justify-content: center;
          }

          & > * {
            a {
              color: var(--bal-color-white) !important
            }
          }
        }
      }
    }
  }
  &:not(.bam-footer--is-compact) {
    .bam-footer__content-wrapper {
      .bam-footer__meta-list-wrapper {
        margin-top: 4rem;

        @include desktop {
          margin-top: 1rem
        }

        .bam-footer__meta-list{
          @include desktop {
            justify-content: flex-end;
          }

          & > * {
            a {
              text-decoration: none;
              font-weight: 400 !important;

              &:hover {
                text-decoration: none !important;
                opacity: .5;
              }

              &:visited {
                color: var(--bal-color-white) !important
              }
            }
          }
        }
      }
    }
  }
// ------------ Reduced Compact Version for Form Page ------------ //
  &.bam-footer--is-compact {

    .bam-footer__content-wrapper {
      .container{
        padding-top: 48px;
        padding-bottom: 48px;
      }
      .bam-footer__meta-list {
        flex-direction: row;
        justify-content: flex-start;

        & > * {
          a {
            font-family: var(--bal-font-family-title);
            text-decoration: underline !important;
            font-weight: 700 !important;
          }
        }
      }
    }
  }

// ------------ TCS Version ------------ //
  &.bam-footer--is-tcs {

    .bam-footer__content-wrapper {
      background-color: #EDE1CD;

      * {
        color: #000000;
        font-family: "Museo-Slab-300";
      }
    }
  }
}
